export const errorMessage = 'Ha ocurrido un error, intente nuevamente.';
export const errorAlert = { status: true, type: 'error', message: errorMessage };
